import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, catchError, finalize, map, throwError } from 'rxjs';
import { LoaderService } from '././loader.service';
import { Router } from '@angular/router';

@Injectable()
export class SouthAsianInterceptor implements HttpInterceptor{
    isExceptUrl : boolean = false;
    modifiedRequest!: HttpRequest<unknown>;
    totalNumber: number = 0;
    
    constructor(public loaderService: LoaderService, private router : Router ){

    }

    intercept(request: HttpRequest<any>, next: HttpHandler):Observable<HttpEvent<unknown>>{
        this.totalNumber++;
        this.loaderService.isLoading.next(true);

        const splitUrl =  request.url.split('/')
        const methodUrl = splitUrl[splitUrl.length -1]
        
        if(methodUrl){
              const token = localStorage.getItem('token');
              // const token = '';
              const headers = {
                authorization: `Bearer ${token}`,
              }
              
              if(headers.authorization) {
                this.modifiedRequest = request.clone({
                  setHeaders: headers
              })
              }

              // this.modifiedRequest = request.clone()
           
              return next.handle(this.modifiedRequest).pipe(map((res:any)=>{
                  return res;
              }),
              catchError((error:any)=>{
                  return throwError(() => {
                      if (error.status == 401 && error.error.error == 'Unauthorized - Token expired') {
                        this.userLogout();
                      }
                      if (error.status == 401 && error.error.msg == 'Unauthorized user') {
                        this.userLogout();
                      }
                      return error.error;
                    });
              }), finalize(() => {
                this.totalNumber--;
                if (this.totalNumber === 0) {
                  this.loaderService.isLoading.next(false);
                }
              })
              )
        }
        return next.handle(request).pipe(            
            map((res: any) => {
              return res;
            }),
            catchError((error: any) => {
              if (error.status == 401 && error.error.msg == 'Unauthorized User') {
                this.userLogout();
              }
              return throwError(() => {
                if (error.status == 0) {
                  return { message: `Please Check Your Internet Connection or Server May be down`, status: 0 };
                }
                return error.error;
              });
            }),
            finalize(() => {
              this.totalNumber--;
              if (this.totalNumber === 0) {
                this.loaderService.isLoading.next(false);
              }
            })
          );
    }

    private userLogout() {
      localStorage.clear();
      this.router.navigate(['/']);
    }
}
